/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupspickprofile2Inputs */

const en_groupspickprofile2 = /** @type {(inputs: Groupspickprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a profile at the top left to see its groups.`)
};

const de_groupspickprofile2 = /** @type {(inputs: Groupspickprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle oben links ein Profil, dann siehst du seine Gruppen.`)
};

/**
* | output |
* | --- |
* | "Pick a profile at the top left to see its groups." |
*
* @param {Groupspickprofile2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupspickprofile2 = /** @type {((inputs?: Groupspickprofile2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupspickprofile2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupspickprofile2(inputs)
	return de_groupspickprofile2(inputs)
});
export { groupspickprofile2 as "groupsPickProfile" }